import { Document, Image, Page, Text, View } from "@react-pdf/renderer";
import CoverWhale from "../images/coverwhale_logo_white.png";

function QuotePDF({ data }) {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumSignificantDigits: 7,
  });

  return (
    <Document title="Certificate of Insurance">
      <Page size="A4">
        <View
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100vh",
          }}
        >
          {/* Header */}
          <View
            style={{
              backgroundColor: "black",
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              padding: 5,
            }}
          >
            <View>
              <Image src={CoverWhale} style={{ width: 270 }} />
            </View>
            <View
              style={{
                color: "white",
                fontSize: 13.5,
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "center",
              }}
            >
              <Text style={{ paddingBottom: 5 }}>
                DOT Number: {data.dot_number}
              </Text>
              <Text style={{ paddingBottom: 5 }}>
                Submission Number: {data.submission_number}
              </Text>
              <Text>Effective Date: {data.effective_date}</Text>
            </View>
          </View>
          {/* Company Name and Total Cost */}
          <View
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              marginTop: 30,
            }}
          >
            <Text
              style={{
                color: "black",
                fontFamily: "Helvetica-Bold",
                fontWeight: "600",
              }}
            >
              Commercial Trucking Quote For:
            </Text>
            <Text
              style={{
                color: "black",
                marginTop: 5,
                fontFamily: "Helvetica-Bold",
                fontWeight: "600",
              }}
            >
              {data.company_name}
            </Text>
          </View>
          <View
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              marginTop: 15,
            }}
          >
            <View
              style={{
                width: 350,
                backgroundColor: "rgb(34 197 94)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingTop: 5,
              }}
            >
              <Text
                style={{
                  color: "white",
                  fontSize: "20px",
                  fontFamily: "Helvetica-Bold",
                  fontWeight: "600",
                }}
              >
                Total Policy Cost:
              </Text>
              <Text
                style={{
                  color: "white",
                  fontSize: "80px",
                  fontFamily: "Helvetica-Bold",
                  fontWeight: "600",
                }}
              >
                {data.total_policy_cost}
              </Text>
            </View>
          </View>
          {/* Cost Details */}
          <View
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 20,
              paddingTop: 30,
              paddingBottom: 0,
            }}
          >
            <View
              style={{
                border: "1px solid rgb(203 213 225)",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 5,
              }}
            >
              {/* Policy premium */}
              <View
                style={{
                  borderBottom: "1px solid rgb(203 213 225)",
                  display: "flex",
                  flexDirection: "row",
                  width: "95%",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingTop: 15,
                  paddingBottom: 15,
                }}
              >
                <Text style={{ color: "rgb(71 85 105)", fontSize: 13 }}>
                  Policy Premium
                </Text>
                <Text style={{ color: "rgb(71 85 105)", fontSize: 13 }}>
                  {data.policy_premium}
                </Text>
              </View>
              {/* Surplus Line & Finance Charges */}
              <View
                style={{
                  borderBottom: "1px solid rgb(203 213 225)",
                  display: "flex",
                  flexDirection: "row",
                  width: "95%",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingTop: 15,
                  paddingBottom: 15,
                }}
              >
                <Text style={{ color: "rgb(71 85 105)", fontSize: 13 }}>
                  Surplus Line & Finance Charges
                </Text>
                <Text style={{ color: "rgb(71 85 105)", fontSize: 13 }}>
                  {data.surplus_line}
                </Text>
              </View>
              {/* Service Fee */}
              <View
                style={{
                  borderBottom: "1px solid rgb(203 213 225)",
                  display: "flex",
                  flexDirection: "row",
                  width: "95%",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingTop: 15,
                  paddingBottom: 15,
                }}
              >
                <Text style={{ color: "rgb(71 85 105)", fontSize: 13 }}>
                  Service Fee
                </Text>
                <Text style={{ color: "rgb(71 85 105)", fontSize: 13 }}>
                  {data.fees}
                </Text>
              </View>
              {/* Total Policy Cost */}
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "95%",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingTop: 15,
                  paddingBottom: 15,
                }}
              >
                <Text
                  style={{
                    color: "rgb(0, 20, 48)",
                    fontSize: 13,
                    fontFamily: "Helvetica-Bold",
                    fontWeight: "600",
                  }}
                >
                  Total Policy Cost
                </Text>
                <Text
                  style={{
                    color: "rgb(0, 20, 48)",
                    fontSize: 13,
                    fontFamily: "Helvetica-Bold",
                    fontWeight: "600",
                  }}
                >
                  {data.policy_cost}
                </Text>
              </View>
            </View>
          </View>
          {/* Coverages */}
          <View
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 20,
              paddingTop: 30,
            }}
          >
            <View
              style={{
                border: "1px solid rgb(203 213 225)",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 5,
              }}
            >
              {/* Title */}
              <View
                style={{
                  borderBottom: "1px solid rgb(203 213 225)",
                  display: "flex",
                  flexDirection: "row",
                  width: "95%",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingTop: 15,
                  paddingBottom: 15,
                }}
              >
                <Text
                  style={{
                    color: "rgb(0, 20, 48)",
                    fontSize: 13,
                    fontFamily: "Helvetica-Bold",
                    fontWeight: "600",
                  }}
                >
                  Coverages
                </Text>
                <Text
                  style={{
                    color: "rgb(0, 20, 48)",
                    fontSize: 13,
                    fontFamily: "Helvetica-Bold",
                    fontWeight: "600",
                  }}
                >
                  Coverage Limit
                </Text>
              </View>
              {data.coverages.map((value, index) => {
                if (index === data.coverages.length - 1) {
                  return (
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "95%",
                        alignItems: "center",
                        justifyContent: "space-between",
                        paddingTop: 15,
                        paddingBottom: 15,
                      }}
                    >
                      <Text style={{ color: "rgb(71 85 105)", fontSize: 13 }}>
                        {value.name}
                      </Text>
                      <Text style={{ color: "rgb(71 85 105)", fontSize: 13 }}>
                        {formatter.format(value.value)}
                      </Text>
                    </View>
                  );
                } else {
                  return (
                    <View
                      style={{
                        borderBottom: "1px solid rgb(203 213 225)",
                        display: "flex",
                        flexDirection: "row",
                        width: "95%",
                        alignItems: "center",
                        justifyContent: "space-between",
                        paddingTop: 15,
                        paddingBottom: 15,
                      }}
                    >
                      <Text style={{ color: "rgb(71 85 105)", fontSize: 13 }}>
                        {value.name}
                      </Text>
                      <Text style={{ color: "rgb(71 85 105)", fontSize: 13 }}>
                        {formatter.format(value.value)}
                      </Text>
                    </View>
                  );
                }
              })}
            </View>
          </View>
        </View>
      </Page>
      <Page size="A4">
        <View
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100vh",
          }}
        >
          {/* Finance Details */}
          <View
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 20,
              paddingTop: 30,
            }}
          >
            <View
              style={{
                border: "1px solid rgb(203 213 225)",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 5,
              }}
            >
              {/* Title */}
              <View
                style={{
                  borderBottom: "1px solid rgb(203 213 225)",
                  display: "flex",
                  flexDirection: "row",
                  width: "95%",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingTop: 15,
                  paddingBottom: 15,
                }}
              >
                <Text
                  style={{
                    color: "rgb(0, 20, 48)",
                    fontSize: 13,
                    fontFamily: "Helvetica-Bold",
                    fontWeight: "600",
                  }}
                >
                  Finance Details
                </Text>
              </View>
              {/* Down Payment */}
              <View
                style={{
                  borderBottom: "1px solid rgb(203 213 225)",
                  display: "flex",
                  flexDirection: "row",
                  width: "95%",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingTop: 15,
                  paddingBottom: 15,
                }}
              >
                <Text style={{ color: "rgb(71 85 105)", fontSize: 13 }}>
                  Down Payment
                </Text>
                <Text style={{ color: "rgb(71 85 105)", fontSize: 13 }}>
                  {data.finance_details.down_payment}
                </Text>
              </View>
              {/* Number Of Payments */}
              <View
                style={{
                  borderBottom: "1px solid rgb(203 213 225)",
                  display: "flex",
                  flexDirection: "row",
                  width: "95%",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingTop: 15,
                  paddingBottom: 15,
                }}
              >
                <Text style={{ color: "rgb(71 85 105)", fontSize: 13 }}>
                  Number Of Payments
                </Text>
                <Text style={{ color: "rgb(71 85 105)", fontSize: 13 }}>
                  {data.finance_details.number_of_payments}
                </Text>
              </View>
              {/* Payment Amount */}
              <View
                style={{
                  borderBottom: "1px solid rgb(203 213 225)",
                  display: "flex",
                  flexDirection: "row",
                  width: "95%",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingTop: 15,
                  paddingBottom: 15,
                }}
              >
                <Text style={{ color: "rgb(71 85 105)", fontSize: 13 }}>
                  Payment Amount
                </Text>
                <Text style={{ color: "rgb(71 85 105)", fontSize: 13 }}>
                  {data.finance_details.payment_amount}
                </Text>
              </View>
              {/* Effective APR */}
              <View
                style={{
                  borderBottom: "1px solid rgb(203 213 225)",
                  display: "flex",
                  flexDirection: "row",
                  width: "95%",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingTop: 15,
                  paddingBottom: 15,
                }}
              >
                <Text style={{ color: "rgb(71 85 105)", fontSize: 13 }}>
                  Effective APR
                </Text>
                <Text style={{ color: "rgb(71 85 105)", fontSize: 13 }}>
                  {data.finance_details.effectiveAPR}
                </Text>
              </View>
              {/* Finance Provider */}
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "95%",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingTop: 15,
                  paddingBottom: 15,
                }}
              >
                <Text style={{ color: "rgb(71 85 105)", fontSize: 13 }}>
                  Finance Provider
                </Text>
                <Text style={{ color: "rgb(71 85 105)", fontSize: 13 }}>
                  {data.finance_details.premiumFinanceProvider}
                </Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
}
export default QuotePDF;
